module.exports = __webpack_public_path__ + "ce82969b8f4202e4fc35484c86ebc167.mp4";